import { CardEnum } from '@colonist/game-states';
import { VictoryPointDataController, VictoryPointTypes } from '@colonist/game-base-types';
export function getHighlightsFromEventHistory(eventHistory) {
    let highlights = [];
    highlights = highlights.concat(getMonopolyHighlights(eventHistory)).concat(getLongestRoadLargestArmyHighlights(eventHistory));
    return highlights;
}
function getMonopolyHighlights(eventHistory) {
    const highlights = [];
    for(let actionIndex = 0; actionIndex < eventHistory.events.length; actionIndex++){
        var _event_stateChange_mechanicDevelopmentCardsState;
        const event = eventHistory.events[actionIndex];
        for(const key in (_event_stateChange_mechanicDevelopmentCardsState = event.stateChange.mechanicDevelopmentCardsState) === null || _event_stateChange_mechanicDevelopmentCardsState === void 0 ? void 0 : _event_stateChange_mechanicDevelopmentCardsState.players){
            var _event_stateChange_mechanicDevelopmentCardsState1;
            const playerColor = Number(key);
            const devCardState = (_event_stateChange_mechanicDevelopmentCardsState1 = event.stateChange.mechanicDevelopmentCardsState) === null || _event_stateChange_mechanicDevelopmentCardsState1 === void 0 ? void 0 : _event_stateChange_mechanicDevelopmentCardsState1.players[playerColor];
            if (devCardState == undefined) continue;
            if (devCardState.developmentCardsUsed == undefined) continue;
            if (devCardState.developmentCardsUsed[devCardState.developmentCardsUsed.length - 1] != CardEnum.Monopoly) continue;
            highlights.push({
                actionIndex: actionIndex,
                type: 'monopolyPlayed'
            });
        }
    }
    return highlights;
}
function getLongestRoadLargestArmyHighlights(eventHistory) {
    const highlights = [];
    let largestArmyGotForLastTimeAt;
    let longestRoadGotForLastTimeAt;
    for(let actionIndex = 0; actionIndex < eventHistory.events.length; actionIndex++){
        const event = eventHistory.events[actionIndex];
        for(const key in event.stateChange.playerStates){
            const playerColor = Number(key);
            const playerState = event.stateChange.playerStates[playerColor];
            if ((playerState === null || playerState === void 0 ? void 0 : playerState.victoryPointsState) == undefined) continue;
            for (const victoryPointTypeKey of Object.keys(playerState.victoryPointsState)){
                const victoryPointType = Number(victoryPointTypeKey);
                const victoryPointStateValue = playerState.victoryPointsState[victoryPointType];
                if (Boolean(victoryPointStateValue) === false) {
                    continue;
                }
                const victoryPointData = VictoryPointDataController.getVictoryPointByType(victoryPointType);
                if ((victoryPointData === null || victoryPointData === void 0 ? void 0 : victoryPointData.victoryPointType) == VictoryPointTypes.LargestArmy) {
                    largestArmyGotForLastTimeAt = actionIndex;
                }
                if ((victoryPointData === null || victoryPointData === void 0 ? void 0 : victoryPointData.victoryPointType) == VictoryPointTypes.LongestRoad) {
                    longestRoadGotForLastTimeAt = actionIndex;
                }
            }
        }
    }
    if (largestArmyGotForLastTimeAt != undefined) highlights.push({
        actionIndex: largestArmyGotForLastTimeAt,
        type: 'largestArmy'
    });
    if (longestRoadGotForLastTimeAt != undefined) highlights.push({
        actionIndex: longestRoadGotForLastTimeAt,
        type: 'longestRoad'
    });
    return highlights;
}
